import { render, staticRenderFns } from "./ADevice.vue?vue&type=template&id=04a37056&scoped=true"
import script from "./ADevice.vue?vue&type=script&lang=js"
export * from "./ADevice.vue?vue&type=script&lang=js"
import style0 from "./ADevice.vue?vue&type=style&index=0&id=04a37056&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a37056",
  null
  
)

export default component.exports